import React from 'react';
import { FileTextIcon, CpuIcon, FileCheck2Icon, ArrowRightIcon } from 'lucide-react';
const nodes = [{
  icon: FileTextIcon,
  label: 'Prompt',
  sub: 'talimatınız',
  tone: 'bg-white text-plum border-grape/20',
  iconTone: 'bg-lilac-soft text-grape'
}, {
  icon: CpuIcon,
  label: 'Yapay zekâ',
  sub: 'ChatGPT · Claude · Gemini · DeepSeek',
  tone: 'bg-plum text-white border-plum',
  iconTone: 'bg-grape text-white'
}, {
  icon: FileCheck2Icon,
  label: 'Sonuç',
  sub: 'düzenlenmiş çıktı',
  tone: 'bg-white text-plum border-blush/30',
  iconTone: 'bg-blush-soft text-blush'
}];
export function PromptFlow() {
  return <div className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-center" aria-label="Bir prompt nasıl çalışır" data-id="element-235" data-mp="2zjphnu8gttck">
      {nodes.map((n, i) => <React.Fragment key={n.label} data-id="element-236" data-mp="1567rdzgoeidu" data-mpi={i}>
          <div className={`flex items-center gap-3 rounded-2xl border px-4 py-3 sm:w-52 ${n.tone}`} data-id="element-237" data-mp="1579c6vnhuj8r">
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${n.iconTone}`} data-id="element-238" data-mp="1a5u6yfjz8apt">
              <n.icon className="h-5 w-5" data-id="element-239" data-mp="1f11jap8hh4ft" />
            </span>
            <div className="min-w-0" data-id="element-240" data-mp="1a8qhthy3hal5">
              <p className="font-display text-base font-black" data-id="element-241" data-mp="1a7p93k4jx06l">{n.label}</p>
              <p className="truncate text-xs opacity-70" data-id="element-242" data-mp="15ap1h4s1zpdd">{n.sub}</p>
            </div>
          </div>
          {i < nodes.length - 1 && <ArrowRightIcon className="mx-auto h-5 w-5 rotate-90 text-grape sm:mx-0 sm:rotate-0" aria-hidden="true" data-id="element-243" data-mp="108znbg9javl2" />}
        </React.Fragment>)}
    </div>;
}